"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
import Link from "next/link";
interface RippleButtonProps {
  children: React.ReactNode;
  as?: "button" | typeof Link | "a";
  href?: string;
  className?: string;
  // React.MouseEvent<HTMLElement> is a supertype of all element-specific mouse event
  // handlers (HTMLAnchorElement, HTMLButtonElement), keeping this contravariant-safe.
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  onHoverChange?: (hovered: boolean) => void;
}
export default function RippleButton(t0) {
  const $ = _c(30);
  let children;
  let className;
  let href;
  let onClick;
  let onHoverChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      as: t1,
      href,
      className,
      onClick,
      onHoverChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = href;
    $[4] = onClick;
    $[5] = onHoverChange;
    $[6] = props;
    $[7] = t1;
  } else {
    children = $[1];
    className = $[2];
    href = $[3];
    onClick = $[4];
    onHoverChange = $[5];
    props = $[6];
    t1 = $[7];
  }
  const Component = t1 === undefined ? "button" : t1;
  const buttonRef = useRef(null);
  const rippleRef = useRef(null);
  const rectRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  let t2;
  if ($[8] !== onHoverChange) {
    t2 = hovered => {
      setIsHovered(hovered);
      if (onHoverChange) {
        onHoverChange(hovered);
      }
    };
    $[8] = onHoverChange;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const setHoverState = t2;
  const getCoordinates = _temp;
  let t3;
  if ($[10] !== isHovered || $[11] !== setHoverState) {
    t3 = event_0 => {
      if (isHovered || !buttonRef.current || !rippleRef.current) {
        return;
      }
      setHoverState(true);
      const el = buttonRef.current;
      const ripple = rippleRef.current;
      const rect = el.getBoundingClientRect();
      rectRef.current = rect;
      const size = Math.max(rect.width, rect.height) * 2.5;
      const {
        clientX,
        clientY
      } = getCoordinates(event_0);
      const x = clientX - rect.left - size / 2;
      const y = clientY - rect.top - size / 2;
      ripple.style.width = `${size}px`;
      ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      ripple.classList.remove("ripple-leave");
      ripple.classList.add("ripple-enter");
    };
    $[10] = isHovered;
    $[11] = setHoverState;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const createRipple = t3;
  let t4;
  if ($[13] !== setHoverState) {
    t4 = event_1 => {
      if (!buttonRef.current || !rippleRef.current) {
        return;
      }
      setHoverState(false);
      const el_0 = buttonRef.current;
      const ripple_0 = rippleRef.current;
      const rect_0 = rectRef.current || el_0.getBoundingClientRect();
      const size_0 = Math.max(rect_0.width, rect_0.height) * 2.5;
      let clientX_0;
      let clientY_0;
      if ("changedTouches" in event_1 && event_1.changedTouches.length > 0) {
        clientX_0 = event_1.changedTouches[0].clientX;
        clientY_0 = event_1.changedTouches[0].clientY;
      } else {
        if ("clientX" in event_1) {
          clientX_0 = (event_1 as React.MouseEvent).clientX;
          clientY_0 = (event_1 as React.MouseEvent).clientY;
        } else {
          clientX_0 = rect_0.left + rect_0.width / 2;
          clientY_0 = rect_0.top + rect_0.height / 2;
        }
      }
      const x_0 = clientX_0 - rect_0.left - size_0 / 2;
      const y_0 = clientY_0 - rect_0.top - size_0 / 2;
      ripple_0.style.left = `${x_0}px`;
      ripple_0.style.top = `${y_0}px`;
      ripple_0.classList.remove("ripple-enter");
      ripple_0.classList.add("ripple-leave");
      const handleAnimationEnd = () => {
        if (ripple_0) {
          ripple_0.classList.remove("ripple-leave");
          ripple_0.removeEventListener("animationend", handleAnimationEnd);
        }
      };
      ripple_0.addEventListener("animationend", handleAnimationEnd);
    };
    $[13] = setHoverState;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const removeRipple = t4;
  let t5;
  if ($[15] !== isHovered) {
    t5 = event_2 => {
      if (!buttonRef.current || !rippleRef.current || !isHovered) {
        return;
      }
      const ripple_1 = rippleRef.current;
      const rect_1 = rectRef.current;
      if (!rect_1) {
        return;
      }
      const size_1 = Math.max(rect_1.width, rect_1.height) * 2.5;
      const {
        clientX: clientX_1,
        clientY: clientY_1
      } = getCoordinates(event_2);
      const x_1 = clientX_1 - rect_1.left - size_1 / 2;
      const y_1 = clientY_1 - rect_1.top - size_1 / 2;
      ripple_1.style.left = `${x_1}px`;
      ripple_1.style.top = `${y_1}px`;
    };
    $[15] = isHovered;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleMouseMove = t5;
  const t6 = href as string;
  const t7 = `relative overflow-hidden ${className || ""}`;
  let t8;
  if ($[17] !== children) {
    t8 = <span className="relative z-10 flex items-center justify-center w-full h-full pointer-events-none">{children}</span>;
    $[17] = children;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span ref={rippleRef} className="ripple" />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== Component || $[21] !== createRipple || $[22] !== handleMouseMove || $[23] !== onClick || $[24] !== props || $[25] !== removeRipple || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t10 = <Component ref={buttonRef as React.RefObject<HTMLButtonElement & HTMLAnchorElement>} href={t6} className={t7} onMouseEnter={createRipple} onMouseLeave={removeRipple} onMouseMove={handleMouseMove} onTouchStart={createRipple} onTouchEnd={removeRipple} onTouchMove={handleMouseMove} onClick={onClick} {...props}>{t8}{t9}</Component>;
    $[20] = Component;
    $[21] = createRipple;
    $[22] = handleMouseMove;
    $[23] = onClick;
    $[24] = props;
    $[25] = removeRipple;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}
function _temp(event) {
  if ("touches" in event && event.touches.length > 0) {
    return {
      clientX: event.touches[0].clientX,
      clientY: event.touches[0].clientY
    };
  }
  return {
    clientX: (event as React.MouseEvent).clientX,
    clientY: (event as React.MouseEvent).clientY
  };
}